import { type CommonAction, success } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";

export interface searchBjhUserArticleParams extends ActiomCommonParams {
    searchValue: string;
}

const parseBjhDom = (domString: string): string => {
    const match = domString.match(/"uk"\s*:\s*"([^"]+)"/);
    if (!match) throw new Error("没有找到 runtime");
    return match[1].trim();
};

export type PublishAction = CommonAction<searchBjhUserArticleParams, Record<string, unknown>[]>;

export const searchBjhUserArticle: PublishAction = async (_task, params) => {
    const http = new Http({
        headers: {
            cookie: "Hmery-Time=948577917; BAIDUID=5A704A91E4CBAFBE1421F0CA634ACA7E:FG=1; BAIDUID_BFESS=5A704A91E4CBAFBE1421F0CA634ACA7E:FG=1",
        },
    });

    // if (!a1Cookie) return {code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: []};
    if (params.searchValue.indexOf("home?from=bjh_article") === -1)
        return { code: 414, message: "请输入正确的百家号用户主页链接地址！", data: [] };

    const result = await http.api<string>({
        method: "get",
        url: params.searchValue,
        defaultErrorMsg: "用户搜索异常，请稍后重试。",
    });

    const runtime = parseBjhDom(result);

    const detailJson = await http.api<{ errno: number; data?: { list: Record<string, unknown>[] } }>({
        method: "get",
        url: "https://mbd.baidu.com/webpage/",
        params: {
            tab: "main",
            num: 10,
            uk: runtime,
            source: "pc",
            type: "newhome",
            action: "dynamic",
            format: "json",
        },
    });
    console.log(detailJson);

    return success(detailJson.data?.list ?? [], `搜索用户相关数据${detailJson.errno === 0 ? "成功！" : "失败！"}`);
};
